import { useState, useEffect, useRef, useCallback } from "react";

const ROTATION_MS = 12000;

/**
 * Hook for the RIGHT column rotation only.
 * Takes all overflow tickets and rotates through them in pages.
 */
export function useRightColumnRotation(tickets, slotsPerPage = 5) {
  const [pageIndex, setPageIndex] = useState(0);
  const timerRef = useRef(null);
  const idKeyRef = useRef("");

  const idKey = tickets.map((t) => t.id).join(",");
  useEffect(() => {
    if (idKey !== idKeyRef.current) {
      idKeyRef.current = idKey;
      setPageIndex(0);
    }
  }, [idKey]);

  const totalPages = Math.max(1, Math.ceil(tickets.length / slotsPerPage));
  const needsRotation = tickets.length > slotsPerPage;
  const safePage = totalPages > 0 ? pageIndex % totalPages : 0;

  const startRotation = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    if (!needsRotation) return;
    timerRef.current = setInterval(() => {
      setPageIndex((prev) => (prev + 1) % totalPages);
    }, ROTATION_MS);
  }, [needsRotation, totalPages]);

  useEffect(() => {
    startRotation();
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [startRotation]);

  const page = tickets.slice(
    safePage * slotsPerPage,
    safePage * slotsPerPage + slotsPerPage
  );

  return { page, pageIndex: safePage, totalPages, needsRotation };
}
